import React, { Component } from 'react'
import { connect } from 'react-redux'
import "whatwg-fetch"

import { jsonResponseHandler } from '../utils/FetchHelper'
import PluginList from "../components/plugins/PluginList"
import { receivePlugins } from '../actions/plugins'
import LoadingBox from "../components/common/LoadingBox";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";

@connect(state => ({}), dispatch => ({
	handleReceivePlugins(plugins) {
		dispatch(receivePlugins(plugins))
	},
	dispatch
}))
class PluginsApp extends Component {

	constructor() {
		super()

		this.state = {
            initialized : InitStatus.INIT_READY,
		}
        this.init = this.init.bind(this);
	}

	componentDidMount() {
		this.init();
    }

    init() {

		const { handleReceivePlugins, dispatch } = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/plugins.json"), {
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				handleReceivePlugins(data)
				this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                })
			})
            .catch(e => {
                console.error(e);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                })
            });
	}

	render() {
		const { initialized } = this.state

		return (
				<div className="inner_article plugin_article">
					<h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                    { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
                    { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
                    {(initialized === InitStatus.INIT_SUCCESS ) &&
						<PluginList/>
                    }
				</div>
		)
	}
}

export default PluginsApp
